import React from 'react'
import { connect } from 'react-redux'
import { Routes, Route, Navigate } from 'react-router-dom'
import { withRouterProps } from './utils/with-router-props'

import { isEmpty } from 'lodash'
import { routes } from '../constants/routes'

import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { saveAnonymousAuth } from '../actions/auth'

import DevTools from './utils/dev-tools'
// import AuthIndex from './auth/index'
// import AppRoute from './utils/app-route'

import AppIndex from './app/index'
import AdminIndex from './admin/index'

import Home from './pages/home'
import NotFound from './pages/not-found'

// Auth components
import Login from './auth/login'
import Register from './auth/register'
import AuthRouter from './auth/router'
import CreateUser from './auth/create-user'
import PasswordHelp from './auth/password-help'
import AuthHandler from './auth/auth-handler'
import PasswordReset from './auth/password-reset'

import '../assets/scss/app.scss'

import { removeAuth, saveAuth } from '../reducers/auth'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

library.add(fas)
library.add(far)

const ROUTER_PAGES = [routes.authLogin, routes.router, routes.authRegister, routes.authPasswordReset]

function AppRoute({ children, auth, location }) {
    let isAuthenticated = (!isEmpty(auth) && 'authId' in auth) || false
    return isAuthenticated ? children : <Navigate to={routes.authLogin} state={{ from: location }} />
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

class App extends React.Component {
    state = {
        hasAuthRouted: false,
        fireauth: null,
        shouldRoute: false
    }

    triggerAuthRouter = () => {
        const fromState = this.props.location.state && this.props.location.state.from.pathname
            ? this.props.location.state.from.pathname
            : null
        return <Navigate to={routes.router} state={{ from: { pathname: fromState } }} />
    }

    componentDidMount = () => {
        const { dispatch } = this.props
        const fireauth = getAuth(this.props.firebaseApp)
        this.setState({ fireauth })
        onAuthStateChanged(fireauth, firebaseUser => {
            if (firebaseUser) {
                if (firebaseUser.isAnonymous) {
                    console.log('anonymous')
                    dispatch(saveAnonymousAuth(fireauth, firebaseUser))
                } else {
                    dispatch(saveAuth(firebaseUser.toJSON()))
                    const pathname = this.props.location.pathname
                    if (ROUTER_PAGES.indexOf(pathname) !== -1 ||
                        pathname.indexOf('/app/') !== -1 ||
                        pathname.indexOf('/admin/') !== -1
                    ) {
                        this.setState({ hasAuthRouted: true })
                        this.setState({ shouldRoute: true })
                    }
                }
            } else {
                dispatch(removeAuth())
                this.setState({ hasAuthRouted: false })
            }
        })
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (!this.state.hasAuthRouted && !isEmpty(this.props.auth)) {
            if (prevProps.location.pathname !== this.props.location.pathname) {
                const pathname = this.props.location.pathname
                if (ROUTER_PAGES.indexOf(pathname) !== -1 ||
                    pathname.indexOf('/app/') !== -1 ||
                    pathname.indexOf('/admin/') !== -1
                ) {
                    this.setState({ hasAuthRouted: true })
                    this.setState({ shouldRoute: true })
                }
            }
        }
        if (this.state.hasAuthRouted && this.state.shouldRoute) {
            this.setState({ shouldRoute: false })
        }
    }

    render = () => {
        const { auth } = this.props
        if (this.state.shouldRoute) {
            return this.triggerAuthRouter()
        }
        return (
            <>
                <div className="container">
                    <Routes>
                        <Route path={`${routes.adminIndex}*`} element={<AppRoute auth={auth} location={this.props.location}><AdminIndex /></AppRoute>} />
                        <Route path={`${routes.appIndex}*`} element={<AppRoute auth={auth} location={this.props.location}><AppIndex /></AppRoute>} />
                        <Route path={routes.router} element={<AppRoute auth={auth} location={this.props.location}><AuthRouter /></AppRoute>} />
                        <Route path={routes.index} element={<Home />} />
                        <Route path={routes.authLogin} element={<Login fireauth={this.state.fireauth} />} />
                        <Route path={routes.authRegister} element={<Register fireauth={this.state.fireauth} />} />
                        <Route path={routes.authPasswordHelp} element={<PasswordHelp fireauth={this.state.fireauth} />} />
                        <Route path={routes.authHandler} element={<AuthHandler fireauth={this.state.fireauth} />} />
                        <Route path={routes.authPasswordReset} element={<PasswordReset fireauth={this.state.fireauth} />} />
                        <Route path={routes.authCreateUser} element={<CreateUser />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
                <DevTools />
            </>
        )
    }
}

export default withRouterProps(connect(mapStateToProps)(App))
